// hooks/useDashboardData.js
import { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';
import api from '../services/api'; // Assumindo que você tem um service de API

export const useDashboardData = (endpoint, filtros = {}) => {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const carregarDados = useCallback(async () => {
    if (!endpoint) return;

    setLoading(true);
    setError(null);
    
    try {
      // Filtrar valores null/undefined e criar query string
      const filtrosLimpos = Object.entries(filtros)
        .filter(([_, value]) => value !== null && value !== undefined && value !== '')
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
      
      // CORREÇÃO: Garantir que endpoint não tenha /api/ duplicado
      let endpointFinal = endpoint;
      if (endpointFinal.startsWith('/api/')) {
        endpointFinal = endpointFinal.substring(4); // Remove /api
      }
      if (!endpointFinal.startsWith('/')) {
        endpointFinal = '/' + endpointFinal; // Adiciona / se necessário
      }
      
      const params = new URLSearchParams(filtrosLimpos).toString();
      const url = params ? `${endpointFinal}?${params}` : endpointFinal;
      
      console.log('📡 Carregando dados:', url);
      console.log('🔧 baseURL do axios:', api.defaults.baseURL);
      console.log('🌐 URL final será:', api.defaults.baseURL + url);
      
      // Fazer a requisição corrigida
      const response = await api.get(url);
      
      // Verificar se response.data é array ou objeto
      let dadosFormatados = response.data;
      
      if (response.data?.data) {
        dadosFormatados = response.data.data; // Se vem em { data: [...] }
      }
      
      if (!Array.isArray(dadosFormatados)) {
        dadosFormatados = [dadosFormatados]; // Converter objeto para array
      }
      
      setDados(dadosFormatados);
      console.log('✅ Dados carregados:', dadosFormatados.length, 'registros');
      
    } catch (err) {
      console.error('❌ Erro ao carregar dados:', err);
      console.error('🔍 URL que falhou:', err.config?.url);
      console.error('🔍 Base URL:', err.config?.baseURL);
      
      setError(err.response?.data?.message || err.message || 'Erro desconhecido');
      
      // Só mostrar message.error se não for erro de rede comum
      if (!err.message.includes('Network Error')) {
        message.error(`Erro ao carregar dados: ${err.response?.data?.message || err.message}`);
      }
      
      setDados([]);
    } finally {
      setLoading(false);
    }
  }, [endpoint, JSON.stringify(filtros)]);

  useEffect(() => {
    carregarDados();
  }, [carregarDados]);

  // Função para recarregar manualmente
  const recarregar = useCallback(() => {
    message.loading('Atualizando dados...', 1);
    carregarDados();
  }, [carregarDados]);

  return { 
    dados, 
    loading, 
    error, 
    recarregar,
    isEmpty: !loading && dados.length === 0,
    hasData: !loading && dados.length > 0
  };
};

export default useDashboardData;